export default __webpack_public_path__ + "static/media/1.eb7fc4cc.png";